import {Button, MenuItem} from '@material-ui/core';
import React, {useState} from 'react';
import Modal from 'Shared/components/Modal';
import OutlinedSelect from 'Shared/components/OutlinedSelect';
import {processBrokerSpreadsheet} from 'Enrollment/ducks/enrollmentFileProcessing';
import * as O from 'fp-ts/lib/Option';
import {useSelector, useDispatch} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {EnrollmentFileStatusType} from 'Enrollment/models/EnrollmentFileStatusType';
import { isLoaded } from 'Core/models/Async';

export type ExternalUploadQueueProcessConfirmationModalProps = {
  onClose: () => void;
  fileId: string;
};

export enum ExternalUploadQueueProcessOptionType {
  PendingAccountSetup = 1,
  FileProcessingHasBegun = 2,
}

const ExternalUploadQueueProcessConfirmationModal = (props: ExternalUploadQueueProcessConfirmationModalProps) => {
  const {onClose} = props;
  const dispatch = useDispatch();
  const [selectedProcessOptionId, setSelectedProcessOptionId] = useState<O.Option<ExternalUploadQueueProcessOptionType>>(
    O.none
  );
  
  const fileStatusId = EnrollmentFileStatusType.CANCELED;

  const {externalUploadQueueFilters} = useSelector((state: ReducerState) => state.enrollmentFileProcessing);
  const {userClaims} = useSelector((state: ReducerState) => state.user.profile);

  const handleEnrollmentFileProcessOptionChange = (value: ExternalUploadQueueProcessOptionType) => {
    setSelectedProcessOptionId(O.some(value));
  };

  const disableProcessButton = () => O.isNone(selectedProcessOptionId)

  const handleProcessEnrollmentApplication = () => {
    if (O.isSome(selectedProcessOptionId)) {
     if(isLoaded(userClaims)){
      dispatch(
        processBrokerSpreadsheet(props.fileId, selectedProcessOptionId.value, userClaims.Data.firstName + ' ' + userClaims.Data.lastName)
      );
      }
    }
    
    onClose();
  };

  return (
    <Modal open onClose={onClose} title="Processing Actions">
      <div className="enrollment-file-rejects-modal">
        <h4>Please select one of the following processing actions.</h4>
       
          <OutlinedSelect
            className="enrollment-file-rejects-modal__Process-content-Options"
            label="Processing Actions"
            onChange={e =>
              handleEnrollmentFileProcessOptionChange(parseInt(e.target.value, 10) as ExternalUploadQueueProcessOptionType)
            }
            value={O.isSome(selectedProcessOptionId) ? selectedProcessOptionId.value : ''}
          >
            <MenuItem value={ExternalUploadQueueProcessOptionType.PendingAccountSetup}>Pending Account Setup</MenuItem>
            <MenuItem value={ExternalUploadQueueProcessOptionType.FileProcessingHasBegun}>File Processing Has Begun</MenuItem>
          </OutlinedSelect>
        
        <div className="modal__footer modal__footer-enrollment-file-rejects">
          <Button className="modal__footer-enrollment-file-rejects-actions" variant="contained" onClick={onClose}>
            Close
          </Button>
          <Button
            className="modal__footer-enrollment-file-rejects-actions"
            color="primary"
            variant="contained"
            disabled={disableProcessButton()}
            onClick={handleProcessEnrollmentApplication}
          >
            Process
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ExternalUploadQueueProcessConfirmationModal;
